import PlansParent from "../../../../src/components/plans-parent/plans-parent.component.jsx";
import CustomButton from "../../../../src/components/custom-button/custom-button.component.jsx";
import BootstapAccordion1 from "../../../../src/components/bootstap-accordion/bootstap-accordion.component.jsx";
import * as React from 'react';
export default {
  PlansParent,
  CustomButton,
  BootstapAccordion1,
  React
};